import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Brain } from 'lucide-react';
import { Idea } from '../../types/idea-machine';
import { format } from 'date-fns';

interface IdeaDialogProps {
  idea: Idea | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function IdeaDialog({ idea, open, onOpenChange }: IdeaDialogProps) {
  if (!idea) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-white dark:bg-gray-900 dark:border-gray-800">
        <DialogHeader>
          <div className="flex items-start gap-4">
            <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg shrink-0">
              <Brain className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <DialogTitle className="text-xl mb-2 text-gray-900 dark:text-white leading-relaxed">{idea.seedPrompt}</DialogTitle>
              <div className="flex flex-wrap items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                <span className="bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded text-xs font-medium text-gray-600 dark:text-gray-300">
                  {idea.seedCategory}
                </span>
                <span>•</span>
                <span>{idea.content.length} ideas</span>
                <span>•</span>
                <span>{idea.timeSpent}s</span>
                <span className="block w-full sm:w-auto sm:inline text-xs text-gray-400 mt-1 sm:mt-0">
                  {format(new Date(idea.timestamp), 'MMMM d, yyyy • h:mm a')}
                </span>
              </div>
            </div>
          </div>
        </DialogHeader>
        <div className="mt-6 space-y-4 max-h-[60vh] overflow-y-auto pr-2">
          {idea.content.map((item, index) => (
            <div key={index} className="flex gap-4 items-start group p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
              <div className="w-8 h-8 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full text-blue-600 dark:text-blue-400 font-semibold text-sm shrink-0">
                {index + 1}
              </div>
              <p className="flex-1 text-gray-700 dark:text-gray-200 pt-1 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
